import { IEnvironment } from '../environments'

export function getDefaultEnvironment(): IEnvironment {
  return {
    platform: 'web',
    os: 'browser',
    target: 'dev'
  }
}
